<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="设备类型：" prop="device_type">
                <span>{{model.device_type}}</span>
            </el-form-item>
            <el-form-item label="设备ID：" prop="device_id">
                <span>{{model.device_id}}</span>
            </el-form-item>
            <el-form-item label="设备编号：" prop="device_code">
                <span>{{model.device_code}}</span>
            </el-form-item>
            <el-form-item label="通道号：" prop="channel_no">
                <span>{{model.channel_no}}</span>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <span>{{model.remark}}</span>
            </el-form-item>
            <el-form-item label="取消报警时间：" prop="cancel_time">
                <span>{{model.cancel_time}}</span>
            </el-form-item>
            <el-form-item label="操作人ID：" prop="cancel_user_id">
                <span>{{model.cancel_user_id}}</span>
            </el-form-item>
            <el-form-item label="操作人：" prop="cancel_user_name">
                <span>{{model.cancel_user_name}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'alertCancelLogInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                device_type: '',
                device_id: '',
                device_code: '',
                channel_no: '',
                remark: '',
                cancel_time: '',
                cancel_user_id: '',
                cancel_user_name: '',
            },
            getObj:{
                url:'/api/admin/alertcancellog/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>